import React, { useEffect, useState } from "react";
import {MapContainer,TileLayer,WMSTileLayer,GeoJSON,useMapEvents,FeatureGroup,useMap,Marker} from "react-leaflet";
import MarkersAdd from "./MarkersAdd";

function getValue(n) {
  if(n===1){
     return 1
  }
  else{
     return 18 * (n - 1);
  }
}

// Function to extract date part (YYYY-MM-DD) from the full date string
function extractDatePart(dateString) {
  if (!dateString) return '';
  // Extract first 10 characters (YYYY-MM-DD) from strings like "2025-09-26-hr-00-00-00"
  return dateString.substring(0, 10);
}

// Function to add one day to a date string and return in the same format
function addOneDay(dateString) {
  if (!dateString) return dateString;
  
  try {
    const datePart = dateString.substring(0, 10); // "2025-09-26"
    const timePart = dateString.substring(10); // "-hr-00-00-00"
    
    const date = new Date(datePart);
    date.setDate(date.getDate() + 1);
    
    // Format the new date as YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const newDatePart = `${year}-${month}-${day}`;
    
    // Return the complete formatted string
    return newDatePart + timePart;
  } catch (error) {
    console.error('Error adding one day to date:', error);
    return dateString;
  }
}

const Overlays = ({ overlayer }, { index }) => {
  const [preloadLayer, setPreloadLayer] = useState(null);

  useEffect(() => {
    if (overlayer.isPlaying) {
      const nextDate = overlayer.nextdate
      console.log('going to next slide')
      //preloadNextStep(nextDate);
    }
  }, [overlayer]);

  // Check if we need to modify the date
  // Compare only the date part (YYYY-MM-DD) of both dates
  const shouldModifyDate = overlayer.datatype === 'acurain' && 
                          overlayer.date && 
                          overlayer.odate && 
                          extractDatePart(overlayer.date) === extractDatePart(overlayer.odate);

  // Use modified date if conditions are met, otherwise use original date
  const displayDate = shouldModifyDate ? addOneDay(overlayer.date) : overlayer.date;

  let layers;
  if((overlayer.text=="State Boundary")){
    layers = (overlayer.show)
  }
  else if ((overlayer.options === undefined) & (overlayer.subclass === undefined) & (overlayer.class==='Administrative')) {
    layers = (
      <WMSTileLayer
        key={index}
        format="image/png"
        layers={overlayer.layer}
        url={overlayer.link}
        transparent="true"
        minZoom={overlayer.minZoom !== undefined ? overlayer.minZoom : ""}
        zIndex={overlayer.class === "Administrative" ? "15" : "10"}
      />
    );
  }
  else if (!overlayer.options && !overlayer.subclass && overlayer.class === "Model" &&   overlayer.dataset==='global') {
    layers = (
      <WMSTileLayer
        key={`${index}-${overlayer.layer}-${displayDate}-${overlayer.altitude}-${overlayer.datatype}`} 
        format="image/png"
        layers={overlayer.layer}
        url={overlayer.link+(overlayer.datatype).toLowerCase()}
        transparent="true"
        minZoom={overlayer.minZoom !== undefined ? overlayer.minZoom : ""}
        data={getValue(overlayer.date)+overlayer.altitude}
        zIndex={overlayer.class === "Administrative" ? "15" : "10"}
        date={displayDate}
        odate={overlayer.odate}
        pressure={overlayer.altitude}
        opacity={overlayer.opacity / 100}
      />
    );
  }
  else if (!overlayer.options && !overlayer.subclass && overlayer.class === "Model" &&   overlayer.dataset==='regional') {
    layers = (
      <WMSTileLayer
        key={`${index}-${overlayer.layer}-${displayDate}-${overlayer.altitude}-${overlayer.datatype}`} 
        format="image/png"
        layers={overlayer.layer}
        url={overlayer.link+(overlayer.dataset).toLowerCase()+'_'+(overlayer.datatype).toLowerCase()}
        transparent="true"
        minZoom={overlayer.minZoom !== undefined ? overlayer.minZoom : ""}
        data={getValue(overlayer.date)+overlayer.altitude}
        zIndex={overlayer.class === "Administrative" ? "15" : "10"}
        date={displayDate}
        odate={overlayer.odate}
        pressure={overlayer.altitude}
        opacity={overlayer.opacity / 100}
      />
    );
  }
  return <div>{layers}</div>;
};

export default Overlays;



// import React, { useEffect, useState } from "react";
// import { WMSTileLayer } from "react-leaflet";

// function getValue(n) {
//   if (n === 1) {
//     return 1;
//   } else {
//     return 18 * (n - 1);
//   }
// }

// const Overlays = ({ overlayer, index }) => {
//   const [preloadLayer, setPreloadLayer] = useState(null);
//   const [currentDate, setCurrentDate] = useState(overlayer.date);
//   const [isTransitioning, setIsTransitioning] = useState(false);

//   useEffect(() => {
//     if (overlayer.isPlaying) {
//       const nextDate = overlayer.nextdate;
//       preloadNextStep(nextDate);
//     }
//   }, [overlayer]);

//   const preloadNextStep = (nextDate) => {
//     // Simulate fetching the next layer
//     const nextLayer = (
//       <WMSTileLayer
//         key={`${index}-${overlayer.layer}-${nextDate}-${overlayer.altitude}-${overlayer.datatype}`}
//         format="image/png"
//         layers={overlayer.layer}
//         url={overlayer.link + (overlayer.datatype).toLowerCase()}
//         transparent="true"
//         minZoom={overlayer.minZoom !== undefined ? overlayer.minZoom : ""}
//         data={getValue(nextDate) + overlayer.altitude}
//         zIndex={overlayer.class === "Administrative" ? "15" : "10"}
//         date={nextDate}
//         pressure={overlayer.altitude}
//         opacity={overlayer.opacity / 100}
//       />
//     );

//     setPreloadLayer(nextLayer);
//     setIsTransitioning(true); // Start transitioning to the next layer
//   };

//   useEffect(() => {
//     if (isTransitioning && preloadLayer) {
//       const timer = setTimeout(() => {
//         setCurrentDate(overlayer.nextdate); // Update the current date
//         setPreloadLayer(null); // Clear the preloaded layer
//         setIsTransitioning(false); // End the transition
//       }, 5000); // Adjust the delay as needed

//       return () => clearTimeout(timer);
//     }
//   }, [isTransitioning, preloadLayer, overlayer]);

//   let layers;
//   if (overlayer.text === "State Boundary") {
//     layers = overlayer.show;
//   } else if (!overlayer.options && !overlayer.subclass && overlayer.class === "Administrative") {
//     layers = (
//       <WMSTileLayer
//         key={index}
//         format="image/png"
//         layers={overlayer.layer}
//         url={overlayer.link}
//         transparent="true"
//         minZoom={overlayer.minZoom !== undefined ? overlayer.minZoom : ""}
//         zIndex={overlayer.class === "Administrative" ? "15" : "10"}
//       />
//     );
//   } else if (!overlayer.options && !overlayer.subclass && overlayer.class === "Model" && overlayer.dataset === 'global') {
//     layers = (
//       <WMSTileLayer
//         key={`${index}-${overlayer.layer}-${currentDate}-${overlayer.altitude}-${overlayer.datatype}`}
//         format="image/png"
//         layers={overlayer.layer}
//         url={overlayer.link + (overlayer.datatype).toLowerCase()}
//         transparent="true"
//         minZoom={overlayer.minZoom !== undefined ? overlayer.minZoom : ""}
//         data={getValue(currentDate) + overlayer.altitude}
//         zIndex={overlayer.class === "Administrative" ? "15" : "10"}
//         date={currentDate}
//         pressure={overlayer.altitude}
//         opacity={overlayer.opacity / 100}
//       />
//     );
//   } else if (!overlayer.options && !overlayer.subclass && overlayer.class === "Model" && overlayer.dataset === 'regional') {
//     layers = (
//       <WMSTileLayer
//         key={`${index}-${overlayer.layer}-${currentDate}-${overlayer.altitude}-${overlayer.datatype}`}
//         format="image/png"
//         layers={overlayer.layer}
//         url={overlayer.link + (overlayer.dataset).toLowerCase() + '_' + (overlayer.datatype).toLowerCase()}
//         transparent="true"
//         minZoom={overlayer.minZoom !== undefined ? overlayer.minZoom : ""}
//         data={getValue(currentDate) + overlayer.altitude}
//         zIndex={overlayer.class === "Administrative" ? "15" : "10"}
//         date={currentDate}
//         pressure={overlayer.altitude}
//         opacity={overlayer.opacity / 100}
//       />
//     );
//   }

//   return (
//     <div>
//       {isTransitioning ? preloadLayer : layers}
//     </div>
//   );
// };

// export default Overlays;

// import React, { useEffect, useState } from "react";
// import { WMSTileLayer } from "react-leaflet";

// function getValue(n) {
//   if (n === 1) {
//     return 1;
//   } else {
//     return 18 * (n - 1);
//   }
// }

// const Overlays = ({ overlayer, index }) => {
//   const [preloadLayer, setPreloadLayer] = useState(null);
//   const [currentDate, setCurrentDate] = useState(overlayer.date);
//   const [isTransitioning, setIsTransitioning] = useState(false);
//   const [currentOpacity, setCurrentOpacity] = useState(0.8);
//   const [nextOpacity, setNextOpacity] = useState(0);

//   useEffect(() => {
//     if (overlayer.isPlaying) {
//       const nextDate = overlayer.nextdate;
//       preloadNextStep(nextDate);
//     }
//   }, [overlayer]);

//   const preloadNextStep = (nextDate) => {
//     // Simulate fetching the next layer
//     const nextLayer = (
//       <WMSTileLayer
//         key={`${index}-${overlayer.layer}-${nextDate}-${overlayer.altitude}-${overlayer.datatype}`}
//         format="image/png"
//         layers={overlayer.layer}
//         url={overlayer.link + (overlayer.datatype).toLowerCase()}
//         transparent="true"
//         minZoom={overlayer.minZoom !== undefined ? overlayer.minZoom : ""}
//         data={getValue(nextDate) + overlayer.altitude}
//         zIndex={overlayer.class === "Administrative" ? "15" : "10"}
//         date={nextDate}
//         hour={overlayer.hours}
//         pressure={overlayer.altitude}
//         opacity={nextOpacity} // Start with 0 opacity (hidden)
//       />
//     );

//     setPreloadLayer(nextLayer);
//     setIsTransitioning(true); // Start transitioning to the next layer
//   };

//   useEffect(() => {
//     if (isTransitioning && preloadLayer) {
//       const fadeDuration = 5000; // Duration of the fade animation in milliseconds
//       const startTime = Date.now();

//       const animate = () => {
//         const elapsed = Date.now() - startTime;
//         const progress = Math.min(elapsed / fadeDuration, 1);

//         setCurrentOpacity(0.8 - progress); // Fade out current layer
//         setNextOpacity(progress); // Fade in preloaded layer

//         if (progress < 0.8) {
//           requestAnimationFrame(animate); // Continue animation
//         } else {
//           // Animation complete
//           setCurrentDate(overlayer.nextdate); // Update the current date
//           setPreloadLayer(null); // Clear the preloaded layer
//           setIsTransitioning(false); // End the transition
//           setCurrentOpacity(0.8); // Reset opacity for the next cycle
//           setNextOpacity(0); // Reset opacity for the next cycle
//         }
//       };

//       animate();
//     }
//   }, [isTransitioning, preloadLayer, overlayer]);

//   let layers;
//   if (overlayer.text === "State Boundary") {
//     layers = overlayer.show;
//   } else if (!overlayer.options && !overlayer.subclass && overlayer.class === "Administrative") {
//     layers = (
//       <WMSTileLayer
//         key={index}
//         format="image/png"
//         layers={overlayer.layer}
//         url={overlayer.link}
//         transparent="true"
//         minZoom={overlayer.minZoom !== undefined ? overlayer.minZoom : ""}
//         zIndex={overlayer.class === "Administrative" ? "15" : "10"}
//         opacity={currentOpacity} // Controlled opacity for crossfade
//       />
//     );
//   } else if (!overlayer.options && !overlayer.subclass && overlayer.class === "Model" && overlayer.dataset === 'global') {
//     layers = (
//       <WMSTileLayer
//         key={`${index}-${overlayer.layer}-${currentDate}-${overlayer.altitude}-${overlayer.datatype}`}
//         format="image/png"
//         layers={overlayer.layer}
//         url={overlayer.link + (overlayer.datatype).toLowerCase()}
//         transparent="true"
//         minZoom={overlayer.minZoom !== undefined ? overlayer.minZoom : ""}
//         data={getValue(currentDate) + overlayer.altitude}
//         zIndex={overlayer.class === "Administrative" ? "15" : "10"}
//         date={currentDate}
//         pressure={overlayer.altitude}
//         hour={overlayer.hours}
//         opacity={currentOpacity} // Controlled opacity for crossfade
//       />
//     );
//   } else if (!overlayer.options && !overlayer.subclass && overlayer.class === "Model" && overlayer.dataset === 'regional') {
//     layers = (
//       <WMSTileLayer
//         key={`${index}-${overlayer.layer}-${currentDate}-${overlayer.altitude}-${overlayer.datatype}`}
//         format="image/png"
//         layers={overlayer.layer}
//         url={overlayer.link + (overlayer.dataset).toLowerCase() + '_' + (overlayer.datatype).toLowerCase()}
//         transparent="true"
//         minZoom={overlayer.minZoom !== undefined ? overlayer.minZoom : ""}
//         data={getValue(currentDate) + overlayer.altitude}
//         zIndex={overlayer.class === "Administrative" ? "15" : "10"}
//         date={currentDate}
//         hour={overlayer.hours}
//         pressure={overlayer.altitude}
//         opacity={currentOpacity} // Controlled opacity for crossfade
//       />
//     );
//   }

//   return (
//     <div>
//       {layers}
//       {preloadLayer && React.cloneElement(preloadLayer, { opacity: nextOpacity })}
//     </div>
//   );
// };

// export default Overlays;



